import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const NotFound = () => {
  const history = useHistory();

  const handleGoBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.replace("/");
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center w-100 h-100 text-center p20"
      style={{ minHeight: "80vh" }}
    >
      <div style={{ fontSize: "120px", fontWeight: 700, lineHeight: 1 }}>
        404
      </div>
      <h2 className="mt20 mb10">Page not found</h2>
      <p className="mb20 text-muted" style={{ maxWidth: 420 }}>
        The page you are looking for either does not exist or has been disabled
        for this environment.
      </p>
      <Button variant="primary" onClick={handleGoBack}>
        <FontAwesomeIcon icon={faArrowLeft} className="mr10" />
        Go Back
      </Button>
    </div>
  );
};

export default NotFound;
